export const UID_COOKIE = 'tapin_2.0_uid'
export const EXPERIMENT = 'customize_lobby_button_iff_has_favorites_v3'
export const VOICECHAT_EXPERIMENT = 'show_voice_off_option'
